'use client';

import { Button, useToast } from '@ethsign/ui';

import { shortenWalletAddress } from '@ethsign/utils-web';
import { useEffect } from 'react';

import { Loading, ProgressBar } from '@/components';
import { dateFormat } from '@/utils';

import { ContractTable, SideNavigation, TopArea } from '../components';

import { vm } from './PageCtrl';

const Page = () => {
  const { toast } = useToast();
  const { folders, contracts, contractsLoading } = vm.$useSnapshot();

  useEffect(() => {
    vm.getContracts({ page: 1, filter: '', keyword: '' });
    vm.getFolders();
  }, []);

  const columns = [
    {
      header: 'Contract Name',
      accessorKey: 'title',
      cell: ({ row }: any) => {
        const data = row.original;

        return (
          <div>
            <div className="text-sm font-medium">{data.title}</div>
            <div className="mt-1 text-xs font-normal">Last Modified: {dateFormat(data.date)}</div>
          </div>
        );
      }
    },
    {
      header: 'Sent by',
      accessorKey: 'sentBy',
      cell: ({ row }: any) => {
        const data = row.original;
        const { sentBy, sentByName } = data;
        return (
          <div>
            <div className="text-sm font-medium">{sentByName}</div>
            <div className="mt-1 text-xs font-normal">{shortenWalletAddress(sentBy, 'normal')}</div>
          </div>
        );
      }
    },
    {
      header: 'Signing Status',
      accessorKey: 'signers',
      cell: ({ row }: any) => {
        const data = row.original;
        const { totalSigning, currentSigned } = data;
        return (
          <div className="flex flex-row items-center">
            <div className="w-[122px] mr-3">
              <ProgressBar value={(currentSigned / totalSigning) * 100}></ProgressBar>
            </div>
            <span className="text-sm font-medium text-gray-500">
              {currentSigned}/{totalSigning} Signed
            </span>
          </div>
        );
      }
    },
    {
      header: 'Action',
      accessorKey: 'id',
      cell: ({ getValue }: any) => {
        const data = getValue();
        return (
          <div>
            <Button
              variant="outline"
              onClick={() => {
                vm.unHideContracts([data], toast);
              }}
            >
              Restore Contract
            </Button>
          </div>
        );
      }
    }
  ];

  return (
    <div className="h-full flex flex-row w-full bg-white">
      <SideNavigation folders={folders} vm={vm}></SideNavigation>
      <div className="flex-1 h-full flex flex-col relative">
        {contractsLoading && <Loading />}
        <TopArea title="Trash" subtitle="See all your hidden contracts here." hideButton></TopArea>
        <div className="px-5 mt-5 flex-1 overflow-scroll">
          {contracts?.data && (
            <ContractTable
              onQuery={(data: any) => {
                vm.getContracts(data);
              }}
              columns={columns}
              data={contracts as any}
            ></ContractTable>
          )}
        </div>
      </div>
    </div>
  );
};

export default Page;
